import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import shortid from 'shortid'
import moment from '../../../../lib/moment.js'
import get from 'lodash/get'
import find from 'lodash/find'
import { leaveColor } from '../../helpers/color'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'
import { FONTS } from '../../../../constants'

const sumTotalHours = (times) => {
  let sum = 0
  Object.keys(times).map(time => {
    sum += Number(times[time].hours)
    return time
  })
  return sum
}

export const DataInput = (props) => {
  const { task, project, holidaysApproval, leaveRequests, compensateRequests } = props
  const { handleClickCell } = props
  return (
    <Column>
      <Total>{ sumTotalHours(get(task, 'times', [])) }</Total>
      {get(task, 'times', []).map(time => {
        const isWeekend = moment(time.date).day() === 0 || moment(time.date).day() === 6
        const isHoliday = find(holidaysApproval, { date: (moment(time.date).format('YYYY-MM-DD')) })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, time)
        const hasCompensate = timesheetHelper.checkHasCompensateRequest(
          compensateRequests, time, project)

        let day = ''
        let dataType
        let data

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.length > 1 ? CONSTANTS.FULLDAY : hasLeave[0].leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }

        return (
          <Cell
            key={ shortid() }
            day={ day }
            canClick={ isHoliday || hasLeave || hasCompensate }
            onClick={
              (isHoliday || hasLeave || hasCompensate) ?
                () => handleClickCell(dataType, data) : () => {}
            }
          >
            <Hour>{ time.hours === 0 ? '' : time.hours }</Hour>
          </Cell>
        )
      })}
    </Column>
  )
}

export const EmptyInput = (props) => {
  const { holidaysApproval, month, project, leaveRequests, compensateRequests, task } = props
  const { handleClickCell } = props
  const sumTotalProject = get(props, 'sumTotalProject')

  return (
    <Column>
      <Total
        style={ { paddingTop: 10, fontFamily: FONTS.GOTHAM_MEDIUM } }
      >{ sumTotalProject || '' }</Total>
      {get(task, 'times', timesheetHelper.getTableDates(moment(month))).map(time => {
        const isWeekend = moment(time.date).day() === 0 || moment(time.date).day() === 6
        const isHoliday = find(holidaysApproval, { date: (moment(time.date).format('YYYY-MM-DD')) })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, time)
        const hasCompensate = timesheetHelper.checkHasCompensateRequest(
          compensateRequests, time, project)

        let day = ''
        let dataType
        let data

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.length > 1 ? CONSTANTS.FULLDAY : hasLeave[0].leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }

        return (
          <Cell
            key={ shortid() }
            day={ day }
            canClick={ isHoliday || hasLeave || hasCompensate }
            onClick={
              (isHoliday || hasLeave || hasCompensate) ?
                () => handleClickCell(dataType, data) : () => {}
            }
          >
            <Date />
          </Cell>
        )
      })}
    </Column>
  )
}

DataInput.propTypes = {
  holidaysApproval: PropTypes.array,
  leaveRequests: PropTypes.array,
  compensateRequests: PropTypes.array,
  task: PropTypes.object,
  project: PropTypes.object,
  handleClickCell: PropTypes.func.isRequired,
}
DataInput.defaultProps = {
  holidaysApproval: [],
  leaveRequests: [],
  compensateRequests: [],
  task: {},
  project: {},
}
EmptyInput.propTypes = {
  holidaysApproval: PropTypes.array,
  task: PropTypes.object,
  leaveRequests: PropTypes.array,
  compensateRequests: PropTypes.array,
  project: PropTypes.object,
  handleClickCell: PropTypes.func.isRequired,
  month: PropTypes.any,
}
EmptyInput.defaultProps = {
  holidaysApproval: [],
  task: {},
  leaveRequests: [],
  compensateRequests: [],
  project: {},
  month: moment(),
}

const Column = styled.div`
  min-height: fit-content;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Cell = styled.div`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: ${props => { return props.canClick ? 'pointer' : 'default' }};
  border: solid #EAEAEA;
  border-width: 0px 0px 0px 1px;
  background-color: ${(props) => { return leaveColor(props.day) }};
`
const Total = styled.span`
  width: 50px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 0px 0px 1px;
`
const Date = styled.div`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  color: ${(props) => {
    if (props.isToday) return '#ad191f'
    return 'black'
  }};
`
const Hour = styled.span`
  width: 40px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/input-col.js